/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

import "bootstrap/dist/css/bootstrap.min.css";
import Table from "react-bootstrap/Table";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

import RenderDates from "./RenderDates";
// import datesArray from "assets/texts/dates.json";
// import { ThreeSixty } from "@mui/icons-material";

function DatesSite() {
  const calendarStyleDiv = {
    left: 0,
    width: "100%",
    height: 700,
    position: "relative",
    paddingBottom: "75%",
  };
  const calendarStyleFrame = {
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    border: 0,
  };

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Termine" />

      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          pt: 8,
          pb: 8,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          {/* <iframe src="https://calendar.google.com/calendar/embed?src=bachrose.bietingen%40gmail.com&ctz=Europe%2FBerlin" style="border: 0" width="800" height="600" frameborder="0" scrolling="no" /> */}
          <div>
            <MKTypography variant="body2" color="text" mb={2} pb={2}>
              Gerne könnt ihr den Kalender abbonnieren indem ihr unten auf das &quot;Plus&quot; oder
              &quot;Zu Google Kalender hinzufügen&quot; klickt.
            </MKTypography>
            <div style={calendarStyleDiv}>
              {/* <iframe
                src="https://calendar.google.com/calendar/embed?height=1600&wkst=2&ctz=Europe%2FBerlin&showPrint=0&mode=AGENDA&src=YmFjaHJvc2UuYmlldGluZ2VuQGdtYWlsLmNvbQ&color=%23039be5"
                style={calendarStyleFrame}
              ></iframe> */}
              <iframe
                src="https://calendar.google.com/calendar/embed?height=800&wkst=2&ctz=Europe%2FBerlin&showPrint=0&mode=AGENDA&showTz=0&src=YmFjaHJvc2UuYmlldGluZ2VuQGdtYWlsLmNvbQ&color=%23039be5"
                style={calendarStyleFrame}
              ></iframe>
            </div>
          </div>
          {/* <Table key="123" striped responsive mt={8} pt={8}> */}
          {/* <thead>
            <tr>
              <th>Datum</th>
              <th>Termin</th>
            </tr>
          </thead> */}
          {/* <RenderDates />
          </Table> */}
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default DatesSite;
